import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';

import { Store } from 'components/common/types/Store.types';
import { getDealId } from 'store/dealManagement/selectors/getDealId';

export const useDynamicTabName = (): void => {
  const dealName = useSelector((state: Store) => state.dealManagement.commonDeal.dealName);
  const dealId = useSelector(getDealId);

  const defaultTitle = useRef(document.title);

  useEffect(() => {
    document.title = 'New campaign';

    if (dealId.length) document.title = dealId;
    if (dealName.length) document.title = dealName;
  }, [dealName, dealId]);

  useEffect(() => {
    return () => {
      document.title = defaultTitle.current;
    };
  }, []);
};
